import ApiService from '../../utils/fetch';
const inboundDeliveryUrl = `${process.env.REACT_APP_BASE_URL}supply/deliveries/`;

export const fetchHeaderAndLinesData = async (deliveryNo) => {
    const response = await ApiService.get(`${inboundDeliveryUrl}${deliveryNo}`);
    return response.data;
};
